jQuery(document).ready(function($) {
    if ($('.layout-editor').length === 0) {
        return;
    }

    window.onbeforeunload = function() {
        return "Do you really want to leave our brilliant application?";
        //if we return nothing here (just calling return;) then there will be no pop-up question at all
        //return;
    };

    let keys = [];
    $(window).keydown(function(e) {
        keys.push(e.keyCode);




        if (JSON.stringify(keys) === '[91,83]' || JSON.stringify(keys) === '[17,83]') {
            $('.btn-preview').click();
            return false;
        }
    }).keyup(function(e) {
        const index = keys.indexOf(e.keyCode);
        if (index > -1) {

        }
        const newKeys = [];
        keys.forEach(function(key) {
            if (key !== e.keyCode) {
                newKeys.push(key);
            }
        });

        keys = newKeys;
    });

    let originalSource = null;

    $('.btn-preview').click(function() {
        const source = btoa($('textarea[name=code]').val());
        if (originalSource === null) {
            originalSource = $('textarea[name=code]').val();
        }
        const form = $('form.hidden-layout-form');

        const iframe_wrapper = $('.preview-wrapper');
        iframe_wrapper.isLoading();

        const iframe = $('iframe[name=preview]');
        iframe.contents().find('body').html('');

        form.find('input[name=source]').val(source);
        form.submit();

        let checker = setInterval(function() {
            if (iframe_wrapper.find('iframe').contents().find('body').html() === undefined || iframe_wrapper.find('iframe').contents().find('body').html().length > 10) {
                clearInterval(checker);
                iframe_wrapper.doneLoading();
            }
        }, 100);

        return false;
    }).trigger('click');

    $('.btn-download').click(function() {
        const text = $('textarea[name=code]').val();
        const filename = $('.hidden-layout-form input[name=filename]').val();

        downloadFile(text, filename);

        return false;
    });

    $('.btn-save').click(function() {
        // Download the original source before saving
        const filename = 'backup.' + $('.hidden-layout-form input[name=filename]').val();
        downloadFile(originalSource, filename);



        $.post({
            url: 'save',
            data: {
                contents: btoa($('textarea[name=code]').val())
            },
            success: function() {
                squde_flash('Layout gewijzigd', 'success');
            },
            error: function() {
                squde_flash('Er ging iets mis bij het opslaan.', 'alert');
            }
        });

        return false;
    });

    function downloadFile(contents, filename) {
        const element = document.createElement('a');

        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(contents));
        element.setAttribute('download', filename);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    }
});

function print_regular_layout(url) {
    if (window.pressed('alt')) {
        window['pressed_keys'] = [];
        url = url + '?stream=true';
        window.open(url);
    } else {
        window.location.assign(url);
    }
    return false;
}
function print_collection(layout_id, array_of_ids) {
    let url = '/print/collection/' + layout_id + '/' + array_of_ids.join(',');
    if (window.pressed('alt')) {
        url = url + '?stream=true';
        window.open(url);
    } else {
        window.location.assign(url);
    }
    return false;
}
